import React, { useState } from "react";
import { ChevronLeft, ChevronRight, PlayCircle } from "lucide-react";
import { useCarouselWindow } from "./useCarouselWindow";

const interviews = [
  {
    title: "How Institutions Trade Volatility",
    expert: "Gary Shilling",
    source: "Business Insider (YouTube)",
    thumbnail: "https://img.youtube.com/vi/w9QoCKbx6d8/maxresdefault.jpg",
    videoUrl: "https://www.youtube.com/embed/w9QoCKbx6d8",
    watchUrl: "https://www.youtube.com/watch?v=w9QoCKbx6d8",
  },
  {
    title: "Paul Scott: 30-Year Institutional Trading Veteran",
    expert: "Paul Scott",
    source: "WOR Podcast (YouTube)",
    thumbnail: "https://img.youtube.com/vi/CG-ZjjM4xSI/maxresdefault.jpg",
    videoUrl: "https://www.youtube.com/embed/CG-ZjjM4xSI",
    watchUrl: "https://www.youtube.com/watch?v=CG-ZjjM4xSI",
  },
  {
    title: "The Godfather of Trading: Final Warning to the Next Generation",
    expert: "Paul Tudor Jones",
    source: "Titans of Tomorrow (YouTube)",
    thumbnail: "https://img.youtube.com/vi/Qp6S0Onz_iw/maxresdefault.jpg",
    videoUrl: "https://www.youtube.com/embed/Qp6S0Onz_iw",
    watchUrl: "https://www.youtube.com/watch?v=Qp6S0Onz_iw",
  },
  {
    title: "How Mohnish Pabrai Beat the Market by 1,204%",
    expert: "Mohnish Pabrai",
    source: "YouTube",
    thumbnail: "https://img.youtube.com/vi/sOaww-Z3i80/maxresdefault.jpg",
    videoUrl: "https://www.youtube.com/embed/sOaww-Z3i80",
    watchUrl: "https://www.youtube.com/watch?v=sOaww-Z3i80",
  },
  {
    title: "Howard Marks’ Most Iconic Interview",
    expert: "Howard Marks",
    source: "YouTube",
    thumbnail: "https://img.youtube.com/vi/40pRnq-b0r0/maxresdefault.jpg",
    videoUrl: "https://www.youtube.com/embed/40pRnq-b0r0",
    watchUrl: "https://www.youtube.com/watch?v=40pRnq-b0r0",
  },
  {
    title: "Exclusive Interview with PR Sundar – Real Trading Story & Strategy",
    expert: "PR Sundar",
    source: "YouTube",
    thumbnail: "https://img.youtube.com/vi/kXlm5V7U0Ug/maxresdefault.jpg",
    videoUrl: "https://www.youtube.com/embed/kXlm5V7U0Ug",
    watchUrl: "https://www.youtube.com/watch?v=kXlm5V7U0Ug",
  },
  {
    title: "Vijay Kedia’s Top Stock Picks & Market Strategy",
    expert: "Vijay Kedia",
    source: "NDTV Profit",
    thumbnail: "https://img.youtube.com/vi/_ZW0FzxqT1A/maxresdefault.jpg",
    videoUrl: "https://www.youtube.com/embed/_ZW0FzxqT1A",
    watchUrl: "https://www.youtube.com/watch?v=_ZW0FzxqT1A",
  },
  {
    title: "Elite Trader: Managing $25 Million at Just 25 Years Old",
    expert: "Ted Zhang",
    source: "Words of Rizdom",
    thumbnail: "https://img.youtube.com/vi/kBPMnLaCYGw/maxresdefault.jpg",
    videoUrl: "https://www.youtube.com/embed/kBPMnLaCYGw",
    watchUrl: "https://www.youtube.com/watch?v=kBPMnLaCYGw",
  },
  {
    title: "Meet the 30-Year-Old Richest Forex Trader in Africa",
    expert: "Dapo Willis",
    source: "Success Secrets",
    thumbnail: "https://img.youtube.com/vi/vyis4Mub_nY/maxresdefault.jpg",
    videoUrl: "https://www.youtube.com/embed/vyis4Mub_nY",
    watchUrl: "https://www.youtube.com/watch?v=vyis4Mub_nY",
  },
  {
    title: "Canada’s #1 Youngest 7-Figure Day Trader",
    expert: "Scarface Trades",
    source: "Words of Rizdom Podcast",
    thumbnail: "https://img.youtube.com/vi/-ApTW2Nb_cE/maxresdefault.jpg",
    videoUrl: "https://www.youtube.com/embed/-ApTW2Nb_cE",
    watchUrl: "https://www.youtube.com/watch?v=-ApTW2Nb_cE",
  },
];

export default function ExpertInterviews() {
  const [hoverIndex, setHoverIndex] = useState(null);

  const VISIBLE = 3;

  const { window, next, prev, pause, resume } = useCarouselWindow({
    total: interviews.length,
    visible: 4,
    auto: true,
    interval: 3500,
  });

  return (
    <section className="w-full bg-[#0B0F19] py-24">
      <div className="mx-auto max-w-6xl px-4">
        {/* Header */}
        <div className="mb-10 flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold text-white sm:text-3xl lg:text-3xl">
              Watch Expert &{" "}
              <span className="text-blue-600">Influencer Market Insights</span>
            </h2>

            <p className="mt-1 text-sm text-gray-400 sm:text-base">
              Interviews, strategies & real market advice from global leaders
            </p>
          </div>

          <div className="flex gap-3">
            <button
              onClick={prev}
              className="rounded-full bg-gray-800 p-2 text-white hover:bg-gray-700"
            >
              <ChevronLeft />
            </button>
            <button
              onClick={next}
              className="rounded-full bg-gray-800 p-2 text-white hover:bg-gray-700"
            >
              <ChevronRight />
            </button>
          </div>
        </div>

        {/* Dark Container */}
        <div className="rounded-3xl border border-white/5 bg-[#0B0F19] px-6 py-12 shadow-[0_20px_60px_rgba(0,0,0,0.25)]">
          <div
            onMouseEnter={pause}
            onMouseLeave={resume}
            className="flex gap-8 overflow-x-hidden"
          >
            {window.map((i) => {
              const item = interviews[i];
              return (
                <div
                  key={i}
                  className="min-w-[320px] overflow-hidden rounded-xl border border-white/10 bg-gradient-to-br from-[#12172A] to-[#0B0F19] transition-all duration-300 hover:-translate-y-1 hover:border-blue-500/40"
                >
                  {/* Hover Video */}
                  <div
                    className="relative h-44 cursor-pointer"
                    onMouseEnter={() => setHoverIndex(i)}
                    onMouseLeave={() => setHoverIndex(null)}
                    onClick={() => window.open(item.watchUrl, "_blank")}
                  >
                    {hoverIndex === i ? (
                      <iframe
                        src={`${item.videoUrl}?autoplay=1&mute=1&controls=0&rel=0&playsinline=1`}
                        title={item.title}
                        className="h-full w-full"
                        allow="autoplay; encrypted-media"
                      />
                    ) : (
                      <>
                        <img
                          src={item.thumbnail}
                          alt={item.title}
                          className="h-full w-full object-cover opacity-90"
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                          <PlayCircle className="h-14 w-14 text-white/80" />
                        </div>
                      </>
                    )}
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    <h3 className="text-lg font-semibold text-white">
                      {item.title}
                    </h3>
                    <p className="mt-1 text-sm text-gray-400">{item.expert}</p>
                    <span className="mt-2 inline-block text-xs text-blue-400">
                      {item.source}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Disclaimer */}
        <p className="mx-auto mt-6 max-w-4xl text-center text-xs text-gray-400">
          All videos shown are public YouTube content used for preview purposes.
          Hover previews are muted by default due to browser policies. Clicking
          any video will redirect you to YouTube. Content is for educational
          purposes only and does not constitute financial or investment advice.
        </p>
      </div>
    </section>
  );
}
